@if (isSignedIn()) {
  <footer class="{{ navbarBgClass() }}">
    <div class="footer_container">
      <div class="footer_container-left">
        <a href="https://sqeptech.com/esqep/" target="_blank">
          <img
            [ngSrc]="'sqeptech-logo-white-32x100.png'"
            alt="SQEPtech logo"
            width="108"
            height="32"
            priority
          />
        </a>
      </div>
      <div class="footer_container-center">
        <p>
          &copy; {{ copyrightDate | date: 'yyyy' }}
          <a href="https://sqeptech.com/" target="_blank"> SQEPtech Ltd </a>
          All rights reserved.
        </p>
        <div class="version-info">
          <span class="version-item">{{
            guiBuildVersion() ?? 'Not found'
          }}</span>
          <span class="version-separator">|</span>
          <span class="version-item">
            {{ apiBuildVersion() ?? 'Not found' }}</span
          >
          <span class="version-separator">|</span>
          <span class="version-item">
            {{ csodApiBuildVersion() ?? 'Not found' }}</span
          >
        </div>
      </div>
      <div class="footer_container-right">
        <a href="https://sqeptech.com/privacy-policy/" target="_blank">
          Privacy Policy
        </a>
      </div>
    </div>
  </footer>
}
